import { useMemo } from 'react'
import type { ChatMapMarker } from 'tripPlanner/components/ChatMap/types'
import DrawerDetailMap from '../DrawerDetailMap'
import type { OfferDetailGeoLocation } from './types'

interface Props {
  geoLocation: OfferDetailGeoLocation
  offerName: string
  onEnlarge?: () => void
}

function OfferDetailMap({ geoLocation, offerName, onEnlarge }: Props) {
  const placeId = `offer-${geoLocation.lat}-${geoLocation.lng}`

  const markers = useMemo<Array<ChatMapMarker>>(() => [{
    markerKey: placeId,
    lat: geoLocation.lat,
    lng: geoLocation.lng,
    label: offerName,
  }], [placeId, geoLocation.lat, geoLocation.lng, offerName])

  return (
    <DrawerDetailMap
      markers={markers}
      initialCenterPlaceId={placeId}
      onEnlarge={onEnlarge}
    />
  )
}

export default OfferDetailMap
